import * as React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { IAgentCharges } from '../../models/IAgentCharges';
import { IAgentChargesWithLog } from '../../models/IAgentChargesWithLog';
import { IAgentProfile } from '../../models/IAgentProfile';
import { IToken } from '../../models/IToken';
import { IUser } from '../../models/IUser';
import ConnectionContext from '../../utils/ConnectionContext';
import AgentChargesUpdate from '../Admin/AgentChargesUpdate/AgentChargesUpdate';
import AgentChargesUpdatePreview from '../Admin/AgentChargesUpdatePreview/AgentChargesUpdatePreview';
import AgentContactInfo from '../Admin/AgentContactInfo/AgentContactInfo';
import AgentList from '../Admin/AgentList/AgentList';
import AgentProfile from '../Admin/AgentProfile/AgentProfile';
import AgentTermsServices from '../Admin/AgentTerms/AgentTermsServices';
import AgentExtraTerms from '../Admin/AgentTerms/ExtraTerms';
import AdminDashboard from '../Admin/Dashboard/AdminDashboard';
import EmailArchive from '../Admin/EmailArchive/EmailArchive';
import AgentView from '../Admin/Report/AgentView';
import WelcomeEmail from '../Admin/WelcomeEmail/WelcomeEmail';
import Home from '../Home';
import Layout from '../Layout';
import AgentCharges from '../User/AgentCharges/AgentCharges';
import AgentChargesPreview from '../User/AgentChargesPreview/AgentChargesPreview';
import AgentChargesRevision from '../User/AgentChargesUpdate/AgentChargesUpdate';
import AgentChargesRevisionPreview from '../User/AgentChargesUpdatePreview/AgentChargesUpdatePreview';
import LandingPage from '../User/AgentHome/LandingPage';
import ChangePassword from '../User/ChangePassword/ChangePassword';
import ContactInfo from '../User/Contact/ContactInfo';
import AgentDashboard from '../User/Dashboard/AgentDashboard';
import Login from '../User/Login/Login';
import Reactivation from '../User/Reactivation/Reactivation';
import Register from '../User/Register';
import ResetPassword from '../User/ResetPassword/ResetPassword';
import ExtraTerms from '../User/Terms/ExtraTerms';
import TermsServices from '../User/Terms/TermsServices';
import Verification from '../User/Verification/Verification';
import { IStartPageProps } from './IStartPageProps';
import { IStartPageState } from './IStartPageState';

export default class StartPage extends React.Component<IStartPageProps, IStartPageState> {
    private connectionContext: ConnectionContext;
    private agentCharges: IAgentCharges[];
    private agentProfile: IAgentProfile;
    private agentChargesWithLog: IAgentChargesWithLog[];

    constructor(props: IStartPageProps, state: IStartPageState) {
        super(props);
        this.state = {
            loaded: false,
            userType: 100,
            user: {
                id: '',
                salutation: '',
                firstName: '',
                lastName: '',
                email: '',
                phoneNumber: '',
                password: '',
                emailVerification: true,
                activationCode: '',
                captchaToken: ''
            },
            agent: {
                id: '',
                firmName: '',
                vatRegNo: '',
                emailId: '',
                firmAddress1: '',
                firmAddress2: '',
                city: '',
                state: '',
                countryCode: '',
                countryName: '',
                postalCode: '',
                contactPerson: '',
                companyEmail: '',
                phoneNumber: '',
                agentJurisdiction: []
            },
            terms: {
                id: '',
                agentId: '',
                employees: 0,
                trademarkAttorneys: 0,
                patentAttorneys: 0,
                lawAttorneys: 0,
                rpaLastYear: 0,
                papctLastYear: 0,
                rtaLastYear: 0,
                tamaLastYear: 0,
                tradeProsecRank: 0,
                patentProsecRank: 0,
                anyOtherAward: '',
                indemnityInsurance: '',
                iMaxAmount: 0,
                iCurrency: '',
                iAnnualAggregate: 0,
                aaCurrency: '',
                qtyMgmt: '',
                qtyMgmtStd: '',
                itSec: '',
                itSecStd: '',
                profConduct: '',
                conductCodes: '',
                docketingSystem: '',
                businessTerms: '',
                serviceTerms: false,
                ptoNames: [],
                technicalCompetenceAgent: []
            },
            changeTab: false
        };
        this.connectionContext = new ConnectionContext(this.props.apiUrl);
        this.agentCharges = [];
        this.agentProfile = {
            AgentName: '',
            EmailAddress: '',
            VatRegNo: '',
            FirmAddress1: '',
            FirmAddress2: '',
            City: '',
            State: '',
            PostalCode: '',
            CountryCode: '',
            Country: '',
            ContactPerson: '',
            CPEmailAddress: '',
            PhoneNumber: '',
            ServicesOfferedFor: ''
        }
        this.agentChargesWithLog = [];
    }
    private isTokenNotExpired(): boolean {
        let isTokenNotExpired: boolean = this.connectionContext.getCurrentUserInformation() != null
        if (!isTokenNotExpired) {
            this.setState({ loaded: false, userType: 100 });
        }
        return isTokenNotExpired;
    }
    private checkAuthentication = async (): Promise<void> => {
        let authenticated: boolean = this.isTokenNotExpired();
        if (!authenticated) {
            authenticated = await this.connectionContext.checkRenewalToken();
        }

        if (authenticated) {
            this.getUserInformation();
        }

    }

    private getUserInformation = async (): Promise<void> => {
        try {
            let userData: IUser = await this.connectionContext.get("UserData");

            this.setState((prevState: IStartPageState): IStartPageState => {

                if (userData != null) {
                    prevState.user = userData;
                }

                let token: IToken | null = this.connectionContext.getCurrentUserInformation();

                if (token != null) {
                    if (token.userType === "0") {
                        prevState.userType = 0;
                    } else if (token.userType === "1") {
                        prevState.userType = 1;
                    }
                }

                prevState.loaded = true;

                return prevState;
            });
        } catch (error) {
            this.setState((prevState: IStartPageState): IStartPageState => {
                prevState.loaded = false;
                return prevState;
            });
        }
    }

    private firstTimeLoad = (): void => {
        return;
    }

    private changeTab = (): void => {
        this.setState({ changeTab: true });
    }
    public async componentDidMount() {
        this.checkAuthentication();
    }

    public render(): React.ReactElement<IStartPageProps> {
        return (
            <div>
                {
                    (this.state.loaded && this.state.userType === 0 &&
                        <Layout isAuthenticated={this.state.loaded} connectionContext={this.connectionContext} email={this.state.user.email}>
                            <Route exact path='/' component={() => <Redirect to={'/User/Dashboard/AgentDashboard'} />} />
                            <Route exact path='/User/Dashboard/AgentDashboard' component={() => <AgentDashboard connectionContext={this.connectionContext}
                                isAuthenticated={this.getUserInformation} user={this.state.user}
                                selectedTab={this.state.changeTab ? "profile" : (this.state.agent.id === "" && "home" || (this.state.terms.id === "" && "terms" || "charges"))} />} />
                            <Route exact path='/User/AgentHome/LandingPage' component={() => <LandingPage connectionContext={this.connectionContext} isAuthenticated={this.changeTab} />} />
                            <Route exact path='/User/Contact/ContactInfo' component={() => <ContactInfo connectionContext={this.connectionContext}
                                agentMaster={this.state.agent} user={this.state.user} isAuthenticated={this.getUserInformation} />} />
                            <Route exact path='/User/Terms/TermsServices' component={() => <TermsServices connectionContext={this.connectionContext}
                                agentMaster={this.state.agent} terms={this.state.terms} user={this.state.user} isAuthenticated={this.getUserInformation} />} />
                            <Route exact path='/User/Terms/ExtraTerms' component={() => <ExtraTerms connectionContext={this.connectionContext} />} />
                            <Route exact path='/User/AgentCharges/AgentCharges' component={() => <AgentCharges connectionContext={this.connectionContext}
                                agentMaster={this.state.agent} />} />
                            <Route exact path='/User/AgentChargesPreview/AgentChargesPreview' component={() => <AgentChargesPreview connectionContext={this.connectionContext}
                                agentCharges={this.agentCharges} onClose={this.firstTimeLoad} onCancel={this.firstTimeLoad} selectedcountries={""} selectedCountry={""} />} />
                            <Route exact path='/User/AgentChargesUpdate/AgentChargesUpdate' component={() => <AgentChargesRevision connectionContext={this.connectionContext}
                                agentMaster={this.state.agent} />} />
                            <Route exact path='/User/AgentChargesUpdatePreview/AgentChargesUpdatePreview' component={() => <AgentChargesRevisionPreview connectionContext={this.connectionContext}
                                agentCharges={this.agentChargesWithLog} onClose={this.firstTimeLoad} onCancel={this.firstTimeLoad} selectedcountries={""} selectedCountry={""} />} />
                        </Layout>
                    )
                }
                {
                    (this.state.loaded && this.state.userType === 1 &&
                        <Layout isAuthenticated={this.state.loaded} connectionContext={this.connectionContext} email={this.state.user.email}>
                            <Route exact path='/' component={() => <Redirect to={'/Admin/Dashboard/AdminDashboard'} />} />
                            <Route exact path='/Admin/Dashboard/AdminDashboard' component={() => <AdminDashboard connectionContext={this.connectionContext}
                                EmailId={this.state.user.email} />} />
                            <Route exact path='/Admin/AgentList/AgentList' component={() => <AgentList connectionContext={this.connectionContext} />} />
                            <Route exact path='/Admin/AgentView/AgentView' component={() => <AgentView connectionContext={this.connectionContext} />} />
                            <Route exact path='/Admin/AgentPortal/AgentProfile' component={() => <AgentProfile connectionContext={this.connectionContext}
                                agentId={this.state.agent.id || ""} onClose={this.firstTimeLoad} />} />
                            <Route exact path='/Admin/AgentContactInfo/AgentContactInfo' component={() => <AgentContactInfo connectionContext={this.connectionContext}
                                agentProfile={this.agentProfile} />} />
                            <Route exact path='/Admin/AgentTerms/ExtraTerms' component={() => <AgentExtraTerms connectionContext={this.connectionContext} />} />
                            <Route exact path='/Admin/AgentTerms/AgentTermsServices' component={() => <AgentTermsServices connectionContext={this.connectionContext}
                                agentMaster={this.state.agent} terms={this.state.terms} />} />
                            <Route exact path='/Admin/WelcomeEmail/WelcomeEmail' component={() => <WelcomeEmail connectionContext={this.connectionContext} />} />
                            <Route exact path='/Admin/EmailArchive/EmailArchive' component={() => <EmailArchive connectionContext={this.connectionContext} />} />
                            <Route exact path='/Admin/AgentChargesUpdate/AgentChargesUpdate' component={() => <AgentChargesUpdate connectionContext={this.connectionContext}
                                agentMaster={this.state.agent} />} />
                            <Route exact path='/Admin/AgentChargesUpdatePreview/AgentChargesUpdatePreview' component={() => <AgentChargesUpdatePreview connectionContext={this.connectionContext}
                                agentCharges={this.agentChargesWithLog} onClose={this.firstTimeLoad} onCancel={this.firstTimeLoad} selectedcountries={""} selectedCountry={""} />} />
                        </Layout>
                    )
                }
                {
                    ((!this.state.loaded || !this.isTokenNotExpired()) &&
                        <Layout isAuthenticated={this.state.loaded} connectionContext={this.connectionContext} email={""}>
                            <Route exact path='/' component={() => <Home />} />
                            <Route exact path='/User/Register' component={() => <Register connectionContext={this.connectionContext} />} />
                            <Route exact path='/User/Login/Login' component={() => <Login connectionContext={this.connectionContext} onAuthentication={this.getUserInformation} />} />
                            <Route exact path='/User/Verification/Verification' component={() => <Verification connectionContext={this.connectionContext} />} />
                            <Route exact path='/User/ResetPassword/ResetPassword' component={() => <ResetPassword connectionContext={this.connectionContext} />} />
                            <Route exact path='/User/ChangePassword/ChangePassword' component={() => <ChangePassword connectionContext={this.connectionContext} />} />
                            <Route exact path='/User/Reactivation/Reactivation' component={() => <Reactivation connectionContext={this.connectionContext} />} />
                        </Layout>)
                }
            </div>);
    }
}